import { useMemo } from 'react';
import { PageContainer, Tile } from 'components/Layout/PageContainer';
import { Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { PriceChange, TradingMessage } from 'pages/trading/model';
import { TradingMessageDisplay } from 'pages/trading/TradingMessageDisplay';
import { MeasureUnitCode } from 'components/measure-unit/MeasureUnitCode';
import { PromotionKpiMatrix } from 'pages/trading/price/promotion/PromotionKpiMatrix';
import { PromotionTable } from 'pages/trading/price/promotion/PromotionTable';
import { transformData } from 'pages/trading/price/promotion/createPageDataStructures';

export interface MatrixValue {
  value: number;
  comparisonValue?: number;
}

export interface MatrixRow {
  before: MatrixValue;
  promotion: MatrixValue;
  after: MatrixValue;
  unit: MeasureUnitCode;
  title: string;
}

export interface Matrix {
  priceChange: MatrixRow;
  itemsPerDay: MatrixRow;
  gmvPerDay: MatrixRow;
}

export function PricePromotionDetailPage({ message, data }: { message: TradingMessage; data: PriceChange[] }) {
  const kpis = useMemo(() => {
    return transformData(data);
  }, [data]);

  return (
    <div className="standard-page-container">
      <PageContainer>
        <Tile className="col-span-12">
          <Typography variant="h3" sx={{ fontWeight: 700, fontSize: '1.25rem' }}>
            <FormattedMessage id="trading.price_change.promotion.title" />
          </Typography>
        </Tile>
        <Tile className="col-span-12 p-0 bg-white overflow-hidden shadow-none border border-transparent">
          <TradingMessageDisplay message={message} className="bg-white p-6" />
        </Tile>

        <PromotionKpiMatrix matrix={kpis.matrix} />

        <Tile className="p-0 col-span-12 mt-4">
          <PromotionTable data={data} messageId={message.messageId} />
        </Tile>
      </PageContainer>
    </div>
  );
}
